import { render, staticRenderFns } from "./DashboardMemo.vue?vue&type=template&id=29d01d24&"
import script from "./DashboardMemo.vue?vue&type=script&lang=js&"
export * from "./DashboardMemo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMemo.vue?vue&type=style&index=0&id=29d01d24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports